import { cn } from '@/lib/utils'
import type { HealthPeriod } from '@/hooks'

interface PeriodSelectorProps {
  value: HealthPeriod
  onChange: (period: HealthPeriod) => void
}

const periods: { value: HealthPeriod; label: string }[] = [
  { value: '7d', label: '7 days' },
  { value: '30d', label: '30 days' },
  { value: '90d', label: '90 days' },
]

export function PeriodSelector({ value, onChange }: PeriodSelectorProps) {
  return (
    <div className="inline-flex rounded-full bg-gray-100 p-1">
      {periods.map((period) => (
        <button
          key={period.value}
          type="button"
          onClick={() => onChange(period.value)}
          className={cn(
            'rounded-full px-3 py-1.5 text-[13px] font-medium transition-colors',
            value === period.value
              ? 'bg-surface text-gray-900 shadow-sm'
              : 'text-gray-500 hover:text-gray-800'
          )}
        >
          {period.label}
        </button>
      ))}
    </div>
  )
}
